exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.captcha[data-v-0a784b2a] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 888;\n}\n.captcha .captcha-bg[data-v-0a784b2a] {\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.4);\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n.captcha .captcha-bg .content-box[data-v-0a784b2a] {\n  margin: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0a784b2a","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Captcha/src/main.vue
// module id = 60
// module chunks = 1 3 4 5